// AUTO-GENERATED - DO NOT EDIT MANUALLY
// Generated from App\Controller\Dto\Response\SurveyResultResponse

import { DateTimefromISO } from '#lib/helper/date.js';
import type { DateTime } from 'luxon';

export type SurveyResultApiResponse = {
	id: number;
	rating: number;
	comment: string;
	answeredAt: string;
	businessReply: string;
	repliedAt: string | null;
	isRead: boolean;
};

export type SurveyResult = {
	id: number;
	rating: number;
	comment: string;
	answeredAt: DateTime;
	businessReply: string;
	repliedAt: DateTime | null;
	isRead: boolean;
};

export function hydrateSurveyResult(data: SurveyResultApiResponse): SurveyResult {
	return {
		...data,
		answeredAt: DateTimefromISO(data.answeredAt)!,
		repliedAt: DateTimefromISO(data.repliedAt),
	};
}